import React from 'react';
import { FaEye, FaIntercom, FaList, FaRadiationAlt } from 'react-icons/fa';
import CopyToClipboard from '../../../../../core/components/CopyToClipboard';
import { urlWebsite } from '../../../../../../../config';
import { useSocket } from '../../../../../../../hooks/Socket';
import { useModal } from '../../../../../../../hooks/Modal';
import Review from '../../../modules/ReviewInscricaoAvaliador';
import api from 'src/services/api';
import { convertToXLSX } from 'src/utils/download';
import { useLoading } from 'src/hooks/LoadingHook';
import { useToast } from 'src/hooks/Toast';

interface ICreateModule {
  lineData: Record<string, any>;
}

export default function ReviewModule(): JSX.Element {

  const { addModal } = useModal();
  const { addLoading, removeLoading } = useLoading();
  const { addToast } = useToast();

  const openReview = async () => {

    addLoading({ title: 'Carregando', key: 'loading' })
    const list = await api.get('/cientific-monitors', { params: { limitItems: 10000 } })

    const hours: Array<string> = [];

    const listDownload: Array<Array<string>> = [['DATA', 'NOME', 'E-MAIL', 'INSTITUIÇÃO', 'CPF']]

    list?.data?.rows?.map(i => {

      i?.hours?.map(hour => {
        const index = hours.findIndex(a => a === hour)

        if (index < 0) {
          hours.push(hour);
        }

      })


    })

    hours.sort((a, b) => a < b ? -1 : a > b ? 1 : 0)

    hours.map(hour => {

      list?.data?.rows?.map((item) => {

        const index = item?.hours?.findIndex(i => i === hour);
        if (index >= 0) {
          listDownload.push([hour, item?.name, item?.email, item?.company, item?.document_number])
        }

      })

    })

    convertToXLSX(listDownload)
    removeLoading('loading');
    addToast({ title: 'Criado', type: 'success' })
  }


  const moduleCreate = (): JSX.Element => {

    return <div onClick={() => openReview()} style={{ cursor: 'pointer', width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', border: '1px solid #333', margin: '5px' }}>
      <FaList className="hover" style={{ cursor: 'pointer' }} size={20} /></div>;
  }



  return moduleCreate();
}
